import { Switch } from 'react-router-dom';
import React from 'react';
import Landing from '../../pages/Landing';
import LongPage from '../../pages/LongPage';
import PrivateRoute from '../PrivateRoute';
import ShipmentsPage from '../../pages/Shipments';
import SortedReactPage from '../../pages/SortedReact';

const ContentRoutes = () => (
	<Switch>
		<PrivateRoute path="/react" component={SortedReactPage} />
		<PrivateRoute path="/shipments" component={ShipmentsPage} />
		<PrivateRoute path="/long-page" component={LongPage} />
		<PrivateRoute exact path="/" component={Landing} />
	</Switch>
);

export default ContentRoutes;
